import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import WeldsByStatusChart from './WeldsByStatusChart';
import WeldingProgressChart from './WeldingProgressChart';
import InspectionProgressChart from './InspectionProgressChart';
import UserActivityChart from './UserActivityChart';
import WeldingActivityChart from './WeldingActivityChart';
import InspectionActivityChart from './InspectionActivityChart';
import WeldingLogDelayChart from './WeldingLogDelayChart';
import InspectionLogDelayChart from './InspectionLogDelayChart';
import ProductionStageTimeChart from './ProductionStageTimeChart';

class Dashboard extends Component {

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col md="4">
            <WeldsByStatusChart />
            <div className="mt-3">
              <UserActivityChart />
            </div>
            <div className="mt-3">
              <ProductionStageTimeChart />
            </div>
          </Col>
          <Col md="4">
            <WeldingProgressChart />
            <div className="mt-3">
              <WeldingActivityChart />
            </div>
            <div className="mt-3">
              <WeldingLogDelayChart />
            </div>
          </Col>
          <Col md="4">
            <InspectionProgressChart />
            <div className="mt-3">
              <InspectionActivityChart />
            </div>
            <div className="mt-3">
              <InspectionLogDelayChart />
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js